import React from "react";
import Header from "./components/Header/Header";
import Footer from "./components/Footer";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import Login from "./pages/Login";
import SignUp from "./pages/SignUp";
import Home from "./pages/Home";
import AboutUs from "./pages/AboutUs";
import Dashboard from "./pages/Dashboard";
import Teams from "./pages/Teams";
import Table from "./pages/Table";
import Rules from "./pages/Rules";
import DataPrivacy from "./pages/DataPrivacy";
import Impressum from "./pages/Impressum";
import Terms from "./pages/AGBs";
import PlattformProvider from "./components/Platform/PlatformProvider";
import PasswordReset from "./pages/PasswordReset";
import RequestNewPassword from "./pages/NewPassword";
import NewverficationLink from "./pages/NewVerificationLink";
import UpcomingMatches from "./pages/UpcomingMatches";
import TopScorers from "./pages/TopScorer";

const App: React.FC = () => {
  return (
    <Router>
      <PlattformProvider>
        <div className="bg-header-secondary min-h-screen w-full flex flex-col">
          <Header />
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/login" element={<Login />} />
            <Route path="/signup" element={<SignUp />} />
            <Route path="/passwordreset" element={<PasswordReset />} />
            <Route
              path="/requestnewpassword"
              element={<RequestNewPassword />}
            />
            <Route path="/dashboard/*" element={<Dashboard />} />
            <Route path="/teams" element={<Teams />} />
            <Route path="/table" element={<Table />} />
            <Route path="/matches" element={<UpcomingMatches />} />
            <Route path="/AboutUs" element={<AboutUs />} />
            <Route path="/rules" element={<Rules />} />
            <Route path="/privacy" element={<DataPrivacy />} />
            <Route path="/impressum" element={<Impressum />} />
            <Route path="/terms" element={<Terms />} />
            <Route path="/TopScorer" element={<TopScorers />} />
            <Route
              path="/resendverification"
              element={<NewverficationLink />}
            />
          </Routes>
        </div>
        <Footer />
      </PlattformProvider>
    </Router>
  );
};

export default App;
